import { z } from "zod";

/*
  BATTLE NUMBERS. Everything a battle is tuned by, in one place. Battles are
  the "wild" layer: they adapt to the child and, later, take items. Trials
  never use any of this.

  Health and damage are in hit points. A question is worth 10 hit points per
  point (its tier), so a tier-3 question hits for 30, and a ninja's health is
  10 × its rank's trial pass mark (see ninjas.ts). The four card stats each
  do one thing, at the rates below.

  Bump BATTLES_VERSION when the numbers change, so old results can be told
  apart. Coins ride on each event, so a change never rewrites a balance.
*/

export const BATTLES_VERSION = 1;

const RulesSchema = z.object({
  /** Battle length before the fighter's Speed bonus. */
  seconds: z.number().int().positive(),
  /** The child's ninja's health. Every wrong answer costs the enemy's attack. */
  playerHealth: z.number().int().positive(),
  /** Hit points per question point. */
  hitPointsPerPoint: z.number().int().positive(),
  /** Seedling has no trial, so no pass mark to take health from. */
  starterHealth: z.number().int().positive(),
  /** Speed: seconds added to the clock per point. */
  speedSecondsPerPoint: z.number().nonnegative(),
  /** Power: share added to damage per point (0.05 is +5%). */
  powerBonusPerPoint: z.number().nonnegative(),
  /** Stealth: chance to dodge a hit per point (0.04 is 4%). */
  stealthDodgePerPoint: z.number().nonnegative().max(0.1),
  /** Brain: points per free hint, rounded up. */
  brainPointsPerHint: z.number().positive(),
  /** Practice pays one coin per this many right answers. */
  practiceAnswersPerCoin: z.number().int().positive(),
  /** A first trial pass pays this many coins per rank number. */
  trialPassCoinsPerRank: z.number().int().nonnegative(),
});

export const BATTLE_RULES = RulesSchema.parse({
  seconds: 120,
  playerHealth: 10,
  hitPointsPerPoint: 10,
  starterHealth: 50,
  speedSecondsPerPoint: 2,
  powerBonusPerPoint: 0.05,
  stealthDodgePerPoint: 0.04,
  brainPointsPerHint: 2,
  practiceAnswersPerCoin: 2,
  trialPassCoinsPerRank: 10,
});
